import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Container, Box, Tabs, Tab } from '@mui/material';

import TabSystem from './TabSystem';
import TabPersonal from './TabPersonal';
import TabAddressData from './TabAddressData';
import TabMarketingPreferences from './TabMarketingPreferences';
import TabAgeVerification from './TabAgeVerification';
import { dialogShow, dialogClose } from '../../../store/actions/dialogActions';
import { profileEditMode } from '../../../store/actions/profileActions';
import { useMessages } from '../../../hooks/useMessages';

const TABS = {
    SYS: 'system',
    PER: 'personal',
    ADR: 'addressdata',
    MAR: 'marketingpreferences',
    AGE: 'ageverification',
};

const TabsBox = ({ profile }) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id, tab } = useParams();
    const { L } = useMessages();

    const handleChangeTab = (event, tab) => {
        const hasChanges = profile.hasChanges();
        const hasErrors = profile.hasErrors();
        if (hasChanges || hasErrors) {
            dispatch(
                dialogShow(
                    L.dialog_unsaved_changes_title,
                    L.dialog_unsaved_changes_text,
                    () => {
                        dispatch(dialogClose());
                        dispatch(profileEditMode(false));
                        navigate(`/consumer/${id}/${tab}`);
                    }
                )
            );
        } else {
            navigate(`/consumer/${id}/${tab}`);
        }
    };

    return (
        <Container>
            <Box>
                <Tabs
                    value={tab}
                    variant="fullWidth"
                    onChange={handleChangeTab}
                >
                    <Tab label={L.consumerpage_tab_system} value={TABS.SYS} />
                    <Tab label={L.consumerpage_tab_personal} value={TABS.PER} />
                    <Tab label={L.consumerpage_tab_address} value={TABS.ADR} />
                    <Tab
                        label={L.consumerpage_tab_marketing_prefs}
                        value={TABS.MAR}
                    />
                    <Tab
                        label={L.consumerpage_tab_age_verification}
                        value={TABS.AGE}
                    />
                </Tabs>
            </Box>
            <Box>
                {tab === TABS.SYS && <TabSystem profile={profile} />}
                {tab === TABS.PER && <TabPersonal profile={profile} />}
                {tab === TABS.ADR && <TabAddressData profile={profile} />}
                {tab === TABS.MAR && (
                    <TabMarketingPreferences profile={profile} />
                )}
                {tab === TABS.AGE && <TabAgeVerification profile={profile} />}
            </Box>
        </Container>
    );
};

export default TabsBox;
